export default function DefaultIcon({ name, size = 48, title }: { name: string; size: number; title: string }) {
  return (
    <div
      title={title}
      style={{
        display: 'flex',
        width: `${size}px`,
        height: `${size}px`,
        justifyContent: 'center',
        alignItems: 'center',
        borderRadius: '8px',
        fontWeight: '900',
        fontSize: `${size / 2}px`,
        color: 'var(--primary-color)',
        border: '1px solid color(display-p3 0.9333 0.9333 0.9333)',
        background: '#003A9B0D'
      }}
    >
      {name?.toLocaleUpperCase()?.charAt(0)}
    </div>
  )
}
